import React from 'react';
import { Box, VStack, HStack, Label, Text, Icon } from '@medely/ui-kit';

const LowVolume: React.FC = () => {
  return (
    <Box bgColor="surface.backing-1" borderRadius="8px" p={2} mt={2} width="100%">
      <HStack alignItems="flex-start">
        <Icon name="chart-line" variant="custom" color="black" bgColor="grey.100'" />
        <VStack gap={0.5} mb={1} ml={1} alignItems="flex-start">
          <Label size="m" color="state.info.primary">
            This market is just getting started!
          </Label>
          <Text size="s" color="text.primary">
            You’ve applied in a growing area — continue onboarding as a Preferred Pro to get
            notified when new jobs open up.
          </Text>
        </VStack>
      </HStack>
    </Box>
  );
};

export default LowVolume;
